type PairKey = `${string}|${string}`;

export class FontMetrics {
  private ctx: CanvasRenderingContext2D;
  private font: string = "";
  private cache = {
    kerning: new Map<PairKey, number>(),
    charWidth: new Map<string, number>(),
  };

  constructor(element: HTMLElement) {
    const canvas = document.createElement("canvas");
    this.ctx = canvas.getContext("2d")!;
    this.setFontFromElement(element);
  }

  public setFontFromElement(element: HTMLElement): void {
    const cs = window.getComputedStyle(element);
    const font = `${cs.fontStyle} ${cs.fontVariant} ${cs.fontWeight} ${cs.fontSize}/${cs.lineHeight} ${cs.fontFamily}`;
    if (font !== this.font) {
      this.font = font;
      this.ctx.font = this.font;
      this.cache.kerning.clear();
      this.cache.charWidth.clear();
    }
  }

  public getCharWidth(char: string): number {
    if (this.cache.charWidth.has(char)) {
      return this.cache.charWidth.get(char)!;
    }
    const width = this.ctx.measureText(char).width;
    this.cache.charWidth.set(char, width);
    return width;
  }

  public getKerning(charA: string, charB: string): number {
    const pair = `${charA}${charB}`;
    const key: PairKey = `${this.font}|${pair}`;

    if (this.cache.kerning.has(key)) {
      return this.cache.kerning.get(key)!;
    }

    const widthWithKerning = this.ctx.measureText(pair).width;
    const widthWithoutKerning = this.getCharWidth(charA) + this.getCharWidth(charB);

    const kerning = widthWithKerning - widthWithoutKerning;

    this.cache.kerning.set(key, kerning);
    return kerning;
  }

  public measureWord(word: string): number {
    let totalWidth = 0;
    for (let i = 0; i < word.length; i++) {
      const char = word[i];
      totalWidth += this.getCharWidth(char);

      if (i > 0) {
        const prevChar = word[i - 1];
        totalWidth += this.getKerning(prevChar, char);
      }
    }
    return totalWidth;
  }
}
